import { render, staticRenderFns } from "./WritingKpis.vue?vue&type=template&id=332ed2d7&scoped=true&"
import script from "./WritingKpis.vue?vue&type=script&lang=js&"
export * from "./WritingKpis.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "332ed2d7",
  null
  
)

export default component.exports